<template>
  <div>
    <div class="d-left">
      <erp-tree @node-click="nodeClick"></erp-tree>
    </div>
    <div class="d-right">
      <el-button size="mini" style="margin-top: 5px" @click="search()">
        查询
      </el-button>
<!--      <el-button size="mini" style="margin-top: 5px" @click="dialogAdd()">
        添加
      </el-button>-->
      <el-button
        v-if="ERP.isPermission(4008002001)"
        size="mini"
        style="margin-top: 5px"
        @click="deleteAdjust(0)"
      >
        删除
      </el-button>
      <el-button size="mini" style="margin-top: 5px" @click="commitAudit()">
        提交审核
      </el-button>
      <el-button size="mini" style="margin-top: 5px" @click="commitAuditAll()">
        全部提交审核
      </el-button>
      <el-button size="mini" style="margin-top: 5px" @click="importDialog()">
        导入
      </el-button>
<!--      <el-button size="mini" style="margin-top: 5px" @click="downloadExcel()">
        下载原始导入模版
      </el-button>-->
      <el-button size="mini" style="margin-top: 5px" @click="downloadExcel2()">
        下载考核剔除减免导入模版
      </el-button>
      <el-button size="mini" style="margin-top: 5px" @click="excel()">
        导出
      </el-button>
      <el-button size="mini" style="margin-top: 5px" @click="excel2()">
        导出订单明细
      </el-button>
      <el-descriptions :column="2" size="mini" border style="margin-top: 8px">
        <el-descriptions-item label="房产">
          <el-input
            size="mini"
            v-model="form.houseName"
            placeholder="输入房产搜索"
          ></el-input>
        </el-descriptions-item>
        <el-descriptions-item label="审核批次">
          <el-input size="mini" v-model="form.batch" />
        </el-descriptions-item>
        <el-descriptions-item label="状态">
          <el-select v-model="form.status" placeholder="请选择" size="mini">
            <el-option
              v-for="item in auditStatus"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-descriptions-item>
        <el-descriptions-item label="计费周期">
          <el-date-picker
            size="mini"
            v-model="startDate"
            type="date"
            format="yyyy-MM-dd"
            value-format="timestamp"
            placeholder="开始时间"
          ></el-date-picker>
          <span>至</span>
          <el-date-picker
            size="mini"
            v-model="endDate"
            type="date"
            format="yyyy-MM-dd"
            value-format="timestamp"
            placeholder="结束时间"
          ></el-date-picker>
        </el-descriptions-item>
        <el-descriptions-item label="收费项目">
          <el-select
            v-model="chargeItemId"
            size="mini"
            filterable
            clearable
            multiple
            style="width: 70%"
            placeholder="选择收费项目"
          >
            <el-option
              size="mini"
              v-for="item in chargeitem"
              :key="item.id"
              :label="item.chargeItem_name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-descriptions-item>
        <el-descriptions-item></el-descriptions-item>
      </el-descriptions>
      <el-table
        max-height="600px"
        :data="listData"
        border
        style="margin-top: 8px"
        @selection-change="handleSelectionChange"
        v-loading="loading"
      >
        <el-table-column type="selection" width="55" />
        <el-table-column label="房产名称" prop="address" />
        <el-table-column label="年份" prop="year" width="55"/>
        <el-table-column label="类型 " prop="type" width="70"/>
        <el-table-column label="历史总应收调整" prop="total_count_sum" />
        <el-table-column label="历史已缴调整" prop="charge_paid_sum" />
        <el-table-column label="本次总应收调整" prop="total_count" />
        <el-table-column label="本次已缴调整" prop="charge_paid" />
        <el-table-column label="关联账单已缴" prop="all_paid" />
        <el-table-column label="关联账单减免" prop="all_discount" />
        <el-table-column label="状态" prop="status_text" width="60"/>
        <el-table-column label="审核批次" prop="batch" />
        <el-table-column label="审核时间" prop="audit_at" />
        <el-table-column label="更新时间" prop="update_at" />
        <el-table-column label="操作">
          <template slot-scope="data">
            <el-button
              v-if="ERP.isPermission(4008002001)"
              type="text"
              icon="el-icon-delete"
              @click="deleteAdjust(data.row.id)"
            >
              删除记录
            </el-button>
            <el-button
              v-if="data.row.task_id > 0"
              type="text"
              @click="skipFlow(data.row.task_id)"
            >
              跳转流程
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        style="float: right; margin-top: 10px; margin-right: 20px"
        background
        :small="true"
        layout="sizes,prev, pager, next"
        :page-size.sync="form.pageSize"
        :total="totalCount"
        :current-page.sync="form.page"
        :page-sizes="[10, 20, 50, 100, 200, 500, 1000]"
      >
      </el-pagination>
    </div>

    <el-dialog
      title="添加"
      :visible.sync="dialogAddModel"
      width="60%"
      :before-close="handleClose"
      v-loading="loading"
    >
      <el-form ref="form" :model="createData" label-width="100px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="房产">
              <template>
                {{ houseName }}
              </template>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <!-- <el-form-item label="年份">
              <template>
                {{ houseName }}
              </template>
            </el-form-item> -->
          </el-col>
        </el-row>
        <el-divider content-position="left">当期</el-divider>
        <el-form-item label="历史调整合计">
          <template>
            <span>总应收：{{ createData.totalCountSum1 }}</span>
            <el-divider direction="vertical"></el-divider>
            <span>已缴金额：{{ createData.chargePaidSum1 }}</span>
          </template>
        </el-form-item>
        <el-form-item label="本次调整">
          <template>
            <span>总应收：</span>
            <el-input-number
              size="mini"
              :precision="2"
              :controls="false"
              v-model="createData.totalCount1"
            />
            <el-divider direction="vertical"></el-divider>
            <span>已缴金额：</span>
            <el-input-number
              size="mini"
              :precision="2"
              :controls="false"
              v-model="createData.chargePaid1"
            />
          </template>
        </el-form-item>
        <el-divider content-position="left">纯上一年</el-divider>
        <el-form-item label="历史调整合计">
          <template>
            <span>总应收：{{ createData.totalCountSum2 }}</span>
            <el-divider direction="vertical"></el-divider>
            <span>已缴金额：{{ createData.chargePaidSum2 }}</span>
          </template>
        </el-form-item>
        <el-form-item label="本次调整">
          <template>
            <span>总应收：</span>
            <el-input-number
              size="mini"
              :precision="2"
              :controls="false"
              v-model="createData.totalCount2"
            />
            <el-divider direction="vertical"></el-divider>
            <span>已缴金额：</span>
            <el-input-number
              size="mini"
              :precision="2"
              :controls="false"
              v-model="createData.chargePaid2"
            />
          </template>
        </el-form-item>
        <el-divider content-position="left">一年以上两年以内</el-divider>
        <el-form-item label="历史调整合计">
          <template>
            <span>总应收：{{ createData.totalCountSum3 }}</span>
            <el-divider direction="vertical"></el-divider>
            <span>已缴金额：{{ createData.chargePaidSum3 }}</span>
          </template>
        </el-form-item>
        <el-form-item label="本次调整">
          <template>
            <span>总应收：</span>
            <el-input-number
              size="mini"
              :precision="2"
              :controls="false"
              v-model="createData.totalCount3"
            />
            <el-divider direction="vertical"></el-divider>
            <span>已缴金额：</span>
            <el-input-number
              size="mini"
              :precision="2"
              :controls="false"
              v-model="createData.chargePaid3"
            />
          </template>
        </el-form-item>
        <el-divider content-position="left">两年以上</el-divider>
        <el-form-item label="历史调整合计">
          <template>
            <span>总应收：{{ createData.totalCountSum4 }}</span>
            <el-divider direction="vertical"></el-divider>
            <span>已缴金额：{{ createData.chargePaidSum4 }}</span>
          </template>
        </el-form-item>
        <el-form-item label="本次调整">
          <template>
            <span>总应收：</span>
            <el-input-number
              size="mini"
              :precision="2"
              :controls="false"
              v-model="createData.totalCount4"
            />
            <el-divider direction="vertical"></el-divider>
            <span>已缴金额：</span>
            <el-input-number
              size="mini"
              :precision="2"
              :controls="false"
              v-model="createData.chargePaid4"
            />
          </template>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="createAdjsut">保存</el-button>
          <el-button @click="handleClose">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog
      title="导入文件"
      :visible.sync="dialogImportModel"
      width="60%"
      :before-close="handleImportClose"
      v-loading="loading"
    >
      <el-upload
        :action="url"
        :before-remove="beforeRemove"
        :on-success="handleAvatarSuccess"
        accept=".xls,.xlsx"
        :limit="1"
        :on-exceed="handleExceed"
        :file-list="fileList"
        :before-upload="beforeAvatarUpload"
      >
        <el-button size="small" type="primary" class="texts">
          点击上传
        </el-button>
        <div slot="tip" class="el-upload__tip">
          只能上传xls或xlsx文件，且不超过7M
        </div>
      </el-upload>
      <el-button size="mini" @click="delNode"> 删除 </el-button>
      <el-button size="mini" @click="importExcelData"> 导入 </el-button>
      <el-table
        v-if="importType == 1"
        max-height="450px"
        :data="importData"
        border
        style="margin-top: 8px"
        @selection-change="handleSelectionChangeImport"
      >
        <el-table-column prop="houseName" label="房产" />
        <el-table-column prop="type" label="类型" />
        <el-table-column prop="totalCount" label="总金额调整" />
        <el-table-column prop="chargePaid" label="已缴金额调整" />
      </el-table>
      <el-table
        v-if="importType == 2"
        max-height="450px"
        :data="importData"
        border
        style="margin-top: 8px"
        @selection-change="handleSelectionChangeImport"
      >
        <el-table-column prop="id" label="id" />
        <el-table-column prop="houseName" label="房号" />
        <el-table-column prop="customerName" label="客户" />
        <el-table-column prop="chargeItemName" label="收费项目" />
        <el-table-column prop="calcDate" label="计费周期" />
        <el-table-column prop="charge" label="应收金额" />
        <el-table-column prop="chargePaid" label="已缴金额" />
        <el-table-column prop="oweMoney" label="欠费金额" />
        <el-table-column prop="discountMoney" label="剔除金额" />
      </el-table>
    </el-dialog>
    <excel-task
      ref="ExcelTask"
      :excelTask="excelTask"
      :excelTaskId="excelTaskId"
      @close="closeExcelTask"
    />
  </div>
</template>

<script>
import ErpTree from "@/components/Admin/Common/erp-tree";
import imgurl from "@/assets/js/imgurl.js";
import ExcelTask from "@/components/common/excelTask";
export default {
  name: "FinanceTargetAdjust",
  components: {
    ErpTree,
    ExcelTask,
  },
  data() {
    return {
      pid: "",
      houseId: "",
      houseName: "",
      datas: [],
      ids: [],
      startDate: "",
      endDate: "",
      chargeItemId: [],
      form: {
        pindexId: "",
        houseId: "",
        houseName: "",
        status: "",
        batch: "",
        page: 1,
        pageSize: 10,
      },
      totalCount: 0,
      listData: [],
      loading: false,
      dialogAddModel: false,
      createData: {
        houseId: "",
        pindexId: "",
        totalCount1: 0,
        totalCount2: 0,
        totalCount3: 0,
        totalCount4: 0,
        chargePaid1: 0,
        chargePaid2: 0,
        chargePaid3: 0,
        chargePaid4: 0,
        totalCountSum1: 0,
        totalCountSum2: 0,
        totalCountSum3: 0,
        totalCountSum4: 0,
        chargePaidSum1: 0,
        chargePaidSum2: 0,
        chargePaidSum3: 0,
        chargePaidSum4: 0,
      },
      auditStatus: [
        {
          value: "",
          label: "全部",
        },
        {
          value: 1,
          label: "待审核",
        },
        {
          value: 2,
          label: "审核中",
        },
        {
          value: 3,
          label: "已审核",
        },
        {
          value: 4,
          label: "审核不通过",
        },
      ],
      dialogImportModel: false,
      url: "",
      importData: [],
      fileList: [],
      multipleSelection: [],
      chargeitem: [],
      importType: "",
      excelTaskId: "",
      excelTask: false,
    };
  },
  mounted() {
    //加载收费大类（费项）
    this.$myhttp
      .get("admin/common/getChargeitem", {
        "Content-Type": "application/json",
      })
      .then((backdata) => {
        this.chargeitem = backdata.data.data;
      });
    var batch = this.$route.query.batch;
    this.form.batch = batch;
    if (batch) {
      this.search();
    }
    var login = window.localStorage.getItem("login");
    var token = window.localStorage.getItem("token");
    var oa_user_id = window.localStorage.getItem("oa_user_id");
    this.url =
      this.$myhttp.defaults.baseURL +
      "/admin/FinanceTargetAdjust/importExcel?" +
      "login_name=" +
      login +
      "&token=" +
      token +
      "&oa_user_id=" +
      oa_user_id;
  },
  watch: {
    pid(n) {
      this.search();
    },
  },
  methods: {
    nodeClick(data) {
      if (data.type == "project") {
        this.pid = data.id;
      }
      if (data.type == "room") {
        this.houseId = data.id;
      }
      let tree_str = data.tree
        .map((ret) => {
          return ret.name;
        })
        .join("->");
      this.form.houseName = tree_str;
      this.houseName = tree_str;
    },
    search() {
      if (this.pid === 0 && this.form.batch == "") {
        this.$message.error("请选择项目");
        return;
      }
      // this.form.houseId = this.houseId;
      this.form.pindexId = this.pid;
      this.loading = true;
      this.$myhttp
        .post("admin/FinanceTargetAdjust/adjustList", this.form, {
          "Content-Type": "application/json",
        })
        .then((backdata) => {
          if (backdata.data.code == 200) {
            this.listData = backdata.data.data;
            this.totalCount = backdata.data.totalCount;
            this.form.page = backdata.data.page;
            this.form.pageSize = backdata.data.pageSize;
            this.loading = false;
          } else {
            this.$message.error(backdata.data.msg);
            this.loading = false;
          }
        })
        .catch((err) => {
          this.$message.error(err);
          this.loading = false;
        });
    },
    handleSelectionChange(val) {
      this.datas = val;
      let ids = [];
      this.datas.map((req) => {
        ids.push(req.id);
      });
      this.ids = ids;
    },
    dialogAdd() {
      if (this.houseId == "" || this.houseId == 0) {
        this.$message.error("请选择房产");
        return false;
      }
      this.dialogAddModel = true;
      this.viewAdjust(0);
    },
    handleClose() {
      this.dialogAddModel = false;
    },
    createAdjsut() {
      this.loading = true;
      this.createData.houseId = this.houseId;
      this.createData.pindexId = this.pid;
      this.$myhttp
        .post("admin/FinanceTargetAdjust/addAdjust", this.createData, {
          "Content-Type": "application/json",
        })
        .then((backdata) => {
          if (backdata.data.code == 200) {
            this.loading = false;
            this.$message.success(backdata.data.msg);
            this.handleClose();
          } else {
            this.loading = false;
            this.$message.error(backdata.data.msg);
            this.handleClose();
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error(err);
          this.handleClose();
        });
    },
    viewAdjust(id) {
      this.$myhttp
        .post(
          "admin/FinanceTargetAdjust/viewAdjust",
          { id, houseId: this.houseId },
          {
            "Content-Type": "application/json",
          }
        )
        .then((backdata) => {
          if (backdata.data.code == 200) {
            this.createData = backdata.data.data;
          } else {
            this.$message.error(backdata.data.msg);
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    deleteAdjust(id) {
      let ids = [];
      if (id == 0) {
        ids = this.ids;
      } else {
        ids = [id];
      }
      this.$myhttp
        .post(
          "admin/FinanceTargetAdjust/deleteAdjust",
          { ids },
          {
            "Content-Type": "application/json",
          }
        )
        .then((backdata) => {
          if (backdata.data.code == 200) {
            this.$message.success(backdata.data.msg);
            this.search();
          } else {
            this.$message.error(backdata.data.msg);
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    commitAudit() {
      this.$myhttp
        .post(
          "admin/FinanceTargetAdjust/commitAudit",
          { ids: this.ids },
          {
            "Content-Type": "application/json",
          }
        )
        .then((backdata) => {
          if (backdata.data.code == 200) {
            window.open(backdata.data.url, "_blank");
          } else {
            this.$message.error(backdata.data.msg);
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    importDialog() {
      this.dialogImportModel = true;
    },
    handleImportClose() {
      this.dialogImportModel = false;
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.importData = [];
        })
        .catch(() => {});
    },
    handleAvatarSuccess(response, file, fileList) {
      if (response.code == 200) {
        this.importData =
          response.data.data.length > 0 ? response.data.data : [];
        this.importType = response.data.type;
      }
    },
    //超过一个文件
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },
    //限制大小
    beforeAvatarUpload(file) {
      const isLt7M = file.size / 1024 / 1024 < 8;
      if (!isLt7M) {
        this.$message.error("上传文件大小不能超过 8MB!");
      }
      return isLt7M;
    },
    handleSelectionChangeImport(val) {
      this.multipleSelection = val;
    },
    // 删除节点
    delNode() {
      if (this.multipleSelection.length == 0) {
        return;
      }
      let data = [];
      if (this.importData.length == this.multipleSelection.length) {
        this.importData = [];
        this.multipleSelection = [];
      } else {
        this.importData.map((req) => {
          let bool = true;
          this.multipleSelection.map((reqs) => {
            if (req.id == reqs.id) {
              bool = false;
            }
          });
          if (bool) {
            data.push(req);
          }
        });
      }
      this.importData = data;
    },
    importExcelData() {
      this.loading = true;
      let url =
        this.importType == 1
          ? "admin/FinanceTargetAdjust/importData"
          : "admin/FinanceTargetAdjust/importDiscountDetail";
      this.$myhttp
        .post(
          url,
          { data: this.importData },
          {
            "Content-Type": "application/json",
          }
        )
        .then((backdata) => {
          if (backdata.data.code == 200) {
            this.$message.success(backdata.data.msg);
            this.search(1);
            this.loading = false;
            this.handleImportClose();
          } else {
            this.$message.error(backdata.data.msg);
            this.loading = false;
          }
        })
        .catch((err) => {
          this.$message.error(err.message);
          this.loading = false;
        });
    },
    downloadExcel() {
      let url = imgurl + "/excel/目标调整导入模板.xlsx";
      window.open("/office.html#/office?url=" + url, "_blank");
    },
    downloadExcel2() {
      if (this.pid == 0) {
        this.$message.error("请选择项目");
        return;
      }
      let data = {
        pid: this.pid,
        startDate: this.startDate / 1000,
        endDate: this.endDate / 1000,
        chargeItemId: this.chargeItemId,
        houseId: this.houseId,
        targetController: "FinanceTargetAdjust",
        taskName: "考核剔除减免导入模版",
        targetFunction: "excelDiscountDetail",
      };
      this.$myhttp
        .post("admin/ExcelTask/addTask", data, {
          "Content-Type": "application/x-www-form-urlencoded",
        })
        .then((backdata) => {
          // 异步执行成功后
          this.$store.commit("excelTaskAdd");
          this.$message.success("创建导出任务成功");
          this.excelTaskId = backdata.data.excelTaskId;
          this.openExcelTask();
        })
        .catch(function (error) {
          this.$message.error("出错了");
        });
    },
    excel() {
      if (this.pid === 0 && this.form.batch == "") {
        this.$message.error("请选择项目");
        return;
      }
      this.form.pindexId = this.pid;
      this.loading = true;
      this.$myhttp
        .post("admin/FinanceTargetAdjust/excelData", this.form, {
          "Content-Type": "application/json",
        })
        .then((backdata) => {
          if (backdata.data.code == 200) {
            let url = imgurl + backdata.data.data;
            this.loading = false;
            window.open("/office.html#/office?url=" + url, "_blank");
          } else {
            this.$message.error(backdata.data.msg);
            this.loading = false;
          }
        })
        .catch((err) => {
          this.$message.error(err);
          this.loading = false;
        });
    },
    excel2() {
      if (this.pid === 0 && this.form.batch == "") {
        this.$message.error("请选择项目");
        return;
      }
      this.form.pindexId = this.pid;
      this.form.targetController = "FinanceTargetAdjust";
      this.form.taskName = "考核剔除减免订单明细";
      this.form.targetFunction = "excelOrderList";
      this.$myhttp
        .post("admin/ExcelTask/addTask", this.form, {
          "Content-Type": "application/x-www-form-urlencoded",
        })
        .then((backdata) => {
          // 异步执行成功后
          this.$store.commit("excelTaskAdd");
          this.$message.success("创建导出任务成功");
          this.excelTaskId = backdata.data.excelTaskId;
          this.openExcelTask();
        })
        .catch(function (error) {
          this.$message.error("出错了");
        });
    },
    commitAuditAll() {
      if (this.pid == 0 || this.pid == "") {
        this.$message.error("请选择项目");
        return;
      }
      this.$myhttp
        .post(
          "admin/FinanceTargetAdjust/commitAudit",
          { pindexId: this.pid, type: "all" },
          {
            "Content-Type": "application/json",
          }
        )
        .then((backdata) => {
          if (backdata.data.code == 200) {
            window.open(backdata.data.url, "_blank");
          } else {
            this.$message.error(backdata.data.msg);
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    openExcelTask() {
      this.$store.commit("excelTaskClear");
      this.excelTask = true;
      this.$refs.ExcelTask.change(1);
    },
    closeExcelTask() {
      this.excelTask = false;
    },
    skipFlow(taskId) {
      window.open(
        "https://crm.gdzawy.com:9000/#/flow/FlowView?task_id=" + taskId,
        "_blank"
      );
    },
  },
};
</script>

<style>
.d-left {
  border-right: 1px solid #eee;
  width: 250px;
  float: left;
}
.d-right {
  float: right;
  width: calc(100% - 265px);
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Order/FinanceTargetAdjust.vue